import {useEffect} from "react"

export const useSetorSubsetor = (subSetor, devedor, datalakeService, setCaracteristicasState) => {
    // const [devedorChange, setDevedorChange] = useState(null)

    useEffect(() => {
        // if (subSetor && devedor === devedorChange) return
        if (subSetor) return
        if (!devedor) return

        // setDevedorChange(devedor)
        const cnpjRaw =
            typeof devedor === "string"
                ? devedor
                : devedor?.CPFCNPJ || devedor?.value || ""

        const numeric = cnpjRaw.replace(/\D/g, "").substring(0, 14)

        if (numeric.length < 8) {
            setCaracteristicasState(prev => ({
                ...prev,
                setorDevedor: null,
                subSetorDevedor: null,
            }))
            return
        }

        let isActive = true

        const fetchContraparte = async () => {
            try {
                const input = numeric.length === 14 ? "CPFCNPJ" : "RaizCNPJ"
                const value = numeric.length === 14 ? numeric : numeric.substring(0, 8)

                const response = await datalakeService.recuperaDadosContraparte(input, value)

                const data =
                    response?.body?.results?.[0] ||
                    response?.body?.data?.[0] ||
                    response?.data?.results?.[0] ||
                    response?.data?.data?.[0]

                if (!isActive) return

                setCaracteristicasState(prev => ({
                    ...prev,
                    setorDevedor: data?.Setor ?? null,
                    subSetorDevedor: data?.SubSetor ?? null,
                }))
            } catch (err) {
                console.error("Erro contraparte", err)
            }
        }

        fetchContraparte()

        return () => {
            isActive = false
        }
    }, [subSetor, devedor, datalakeService, setCaracteristicasState])
}
